var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeClockMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,255.99828,255.99828",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,24c0,11.044 -8.956,20 -20,20c-11.044,0 -20,-8.956 -20,-20c0,-11.044 8.956,-20 20,-20c11.044,0 20,8.956 20,20z",
    fill: "#0c5d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,24c0,8.838 -7.162,16 -16,16c-8.838,0 -16,-7.162 -16,-16c0,-8.838 7.163,-16 16,-16c8.837,0 16,7.163 16,16z",
    fill: "#eeeeee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,11h2v13h-2z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-11.28732,27.25067) rotate(-45.001)",
    d: "M26.082,22.654h2.337v9.192h-2.337z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24c0,1.657 -1.344,3 -3,3c-1.657,0 -3,-1.343 -3,-3c0,-1.657 1.343,-3 3,-3c1.656,0 3,1.343 3,3",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,24c0,0.551 -0.448,1 -1,1c-0.552,0 -1,-0.449 -1,-1c0,-0.553 0.448,-1 1,-1c0.552,0 1,0.447 1,1",
    fill: "#0c5d90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockMobile);
export default __webpack_public_path__ + "static/media/timeClockMobile.7a5ea7bcbe6958a19619f47bd9338835.svg";
export { ForwardRef as ReactComponent };